'use client';

import React from 'react';
import { Chip, Link } from '@heroui/react';
import { RevshareSubscriber } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

interface UserCellProps {
  subscriber: RevshareSubscriber;
}

const UserCell: React.FC<UserCellProps> = ({ subscriber }) => {
  const { t } = useTranslations();

  // Map new API structure
  const userName = subscriber.name || subscriber.username || 'Unknown';
  const purchasesCount = subscriber.transactions_count || 0;
  const ofUsername = subscriber.username;
  const ofUserUrl = ofUsername ? `https://onlyfans.com/${ofUsername}` : null;

  return (
    <div className="flex flex-col gap-1">
      {/* Row 1: Name with link icon and chat link */}
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1">
          <span className="text-auth-ink text-sm font-semibold">{userName}</span>
          {/* External link icon to OnlyFans profile */}
          {ofUserUrl && (
            <a
              href={ofUserUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.5 1H2.2C1.53726 1 1 1.53726 1 2.2V9.8C1 10.4627 1.53726 11 2.2 11H9.8C10.4627 11 11 10.4627 11 9.8V8.5M7 1H11M11 1V5M11 1L5 7"
                  stroke="#006FEE"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          )}
        </div>
      </div>
      {/* Row 2: Purchases count */}
      {purchasesCount > 0 && (
        <div className="flex items-center">
          <Chip
            size="sm"
            classNames={{
              base: 'bg-[#ECFDF5] h-6 px-2',
              content: 'text-successBright text-xs font-normal p-0',
            }}
          >
            {purchasesCount} {t('partner.revshare.subscribers.purchases')}
          </Chip>
        </div>
      )}
    </div>
  );
};

export default UserCell;
